import identity from 'ramda/src/identity'

import { INIT_APP } from 'root/src/client/logic/app/actionIds'

export default {
	[INIT_APP]: identity,
}
